var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "page-layout-settings" }, [
    _vm.hasSidebar
      ? _c(
          "div",
          { staticClass: "page-layout-settings__sidebar" },
          [_vm._t("sidebar")],
          2
        )
      : _vm._e(),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "page-layout-settings__content" },
      [_vm._t("content")],
      2
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }